<ng-container *mobxAutorun>
  <span [tooltip]="help" [placement]="placement" [delay]="delay">
    <ng-content></ng-content>
  </span>
</ng-container>
